<template>

</template>

<script>
export default {
  name: "ReportsPage"
}
</script>


